import { render, staticRenderFns } from "./item_type.vue?vue&type=template&id=4faf4681&scoped=true&"
import script from "./item_type.vue?vue&type=script&lang=js&"
export * from "./item_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf4681",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4faf4681')) {
      api.createRecord('4faf4681', component.options)
    } else {
      api.reload('4faf4681', component.options)
    }
    module.hot.accept("./item_type.vue?vue&type=template&id=4faf4681&scoped=true&", function () {
      api.rerender('4faf4681', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/master_item/item_type.vue"
export default component.exports